<template>
    <div class="relative cursor-pointer group" :class="containerClass" @click="activate" v-if="!active">
        <img
            v-if="thumbnail"
            :src="thumbnail"
            :alt="alt"
            class="w-full h-full object-cover"
            :class="imageClass"
            loading="lazy"
        />
        <div v-else class="w-full h-full bg-gray-200 dark:bg-gray-800" :class="imageClass" />
        <div class="absolute inset-0 flex flex-col items-center justify-center transition-colors" :class="label ? 'bg-black/50 group-hover:bg-black/60' : 'bg-black/20 group-hover:bg-black/30'">
            <div class="w-16 h-16 md:w-20 md:h-20 bg-white/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                <svg class="w-8 h-8 md:w-10 md:h-10 text-gray-800 ml-1" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z"/>
                </svg>
            </div>
            <!-- Optional caption under the play button (HAP-4516). -->
            <div v-if="label" class="mt-4 mx-4 px-5 py-2 rounded-full bg-gray-900/80 text-center text-white text-base md:text-xl font-semibold tracking-wide shadow-lg">{{ label }}</div>
        </div>
    </div>
    <iframe
        v-else
        :id="iframeId"
        :src="`${embedUrl}?${params}`"
        class="w-full"
        :class="containerClass"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
    />
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
    embedUrl: { type: String, required: true },
    thumbnail: { type: String, default: '' },
    alt: { type: String, default: 'Video' },
    // `autoplay=1` so the click on the facade starts playback in one gesture.
    // Without it the click only swaps the poster for Vimeo's iframe, which then
    // shows its *own* play button — the "press it twice to play" bug. The iframe
    // is injected inside the click handler, so the user gesture carries over and
    // Vimeo honours autoplay with sound (the standard lite-embed pattern).
    params: { type: String, default: 'title=0&byline=0&portrait=0&quality=720p&autoplay=1' },
    containerClass: { type: String, default: 'aspect-video' },
    imageClass: { type: String, default: '' },
    iframeId: { type: String, default: undefined },
    label: { type: String, default: '' },
})

const active = ref(false)
const activate = () => { active.value = true }
</script>
